import React from "react";
import Link from "next/link";

import useAnalyticsActionEvents from "@stadium/services/analytics/hooks/use-action-events";

import { useCurrentUserContext } from "@stadium/hooks/lib/use-current-user";

import { stopEventPropagation } from "@stadium/helpers/resource";
import { getEventName } from "@stadium/helpers/analytics";

import { getPreviewTemplateRoute } from "@constants/routes";
import { JUNE_SO } from "@stadium/services/analytics/constants/services";
import { PREVIEW_TEMPLATE } from "@constants/june-so";

const PreviewTemplateCTA = ({ className = "", pageName = "", feUrl = "", storeName = "" }) => {
  const services = [JUNE_SO];
  const { trackEvent } = useAnalyticsActionEvents(services);
  const { currentUserData: { company = {} } = {} } = useCurrentUserContext();
  const { id: groupId, name: companyName } = company || {};

  const handlePreviewTemplateClicked = (e) => {
    stopEventPropagation(e);
    pageName &&
      trackEvent({
        eventName: getEventName({
          pageName,
          target: PREVIEW_TEMPLATE,
          action: "clicked",
        }),
        eventProperties: {
          shop_name: storeName,
        },
        context: { groupId },
        additionalProps: { companyName },
      });
  };

  return (
    <Link
      href={getPreviewTemplateRoute(feUrl)}
      className={className}
      onClick={handlePreviewTemplateClicked}
      title="Preview Template"
    >
      Preview Template
    </Link>
  );
};

export default PreviewTemplateCTA;
